module.exports = __webpack_public_path__ + "static/media/baseMeme10thumb.a593f517.jpg";